import Empty from './src/empty.mjs';
export { emptyProps } from './src/empty2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElEmpty = withInstall(Empty);

export { ElEmpty, ElEmpty as default };
//# sourceMappingURL=index.mjs.map
